<template>
  <div class="group">
    <div class="group-header">
      <div class="sub-header">
        <h5><span :class='[kind === "content" ? "mailing" : "image"]'></span>グループ<span class="count">{{count}}/{{limit}}</span></h5>
        <div class="operation-area">
          <div
            class="sort normal-btn"
            @click="isShowSortSelect = !isShowSortSelect"
            v-on-clickaway="sortSelectAway"
          >
            並び替え
            <transition>
              <ul class="sort-option drop-down-list" v-show="isShowSortSelect">
                <li :class="{ selected: sort.index === 0 }" @click="changeSort(0, 'manual', 'asc')">指定順</li>
                <li :class="{ selected: sort.index === 1 }" @click="changeSort(1, 'innerId', 'asc')">ID昇順</li>
                <li :class="{ selected: sort.index === 2 }" @click="changeSort(2, 'innerId', 'desc')">ID降順</li>
                <li :class="{ selected: sort.index === 3 }" @click="changeSort(3, 'name', 'asc')">名前昇順</li>
                <li :class="{ selected: sort.index === 4 }" @click="changeSort(4, 'name', 'desc')">名前降順</li>
                <li :class="{ selected: sort.index === 5 }" @click="changeSort(5, 'createdOn', 'asc')">作成日時昇順</li>
                <li :class="{ selected: sort.index === 6 }" @click="changeSort(6, 'createdOn', 'desc')">作成日時降順</li>
                <li :class="{ selected: sort.index === 7 }" @click="changeSort(7, 'createdUserName', 'asc')">作成者名昇順</li>
                <li :class="{ selected: sort.index === 8 }" @click="changeSort(8, 'createdUserName', 'desc')">作成者名降順</li>
                <li :class="{ selected: sort.index === 9 }" @click="changeSort(9, 'savedOn', 'asc')">更新日時昇順</li>
                <li :class="{ selected: sort.index === 10 }" @click="changeSort(10, 'savedOn', 'desc')">更新日時降順</li>
                <li :class="{ selected: sort.index === 11 }" @click="changeSort(11, 'modifiedUserName', 'asc')">更新者名昇順</li>
                <li :class="{ selected: sort.index === 12 }" @click="changeSort(12, 'modifiedUserName', 'desc')">更新者名降順</li>
              </ul>
            </transition>
          </div>
          <div class="search">
            <input
              type="text"
              placeholder="検索"
              v-model="model.searchText"
              @keydown.enter="$utils.event.strictEnter($event, getFolders)"
            />
            <button @click="getFolders"><i class="fas fa-search"></i></button>
          </div>
        </div>
      </div><!-- .sub-header -->
      <div class="check-wrapper">
        <ul class="batch">
          <li v-if="folders.length > 0">
            <input
              id="all-checked"
              type="checkbox"
              @change="check = $event.target.checked"
              :checked="check !== 0 && check === folders.length"
            />
            <label for="all-checked"></label>
          </li>
          <li
            v-if="check"
            class="delete normal-btn"
            @click="deleteConfirm(false)"
          >
            <span>削除</span>
          </li>
        </ul>
        <div class="add-folder">
          <input
            type="text"
            placeholder="グループを追加"
            v-model="model.name"
            @keydown.enter="$utils.event.strictEnter($event, newFolder)"
          />
          <button @click="newFolder" class="w-b-btn">追加</button>
        </div>
      </div><!-- .check-wrapper -->
    </div><!-- .group-header -->
    <div class="group-main">
      <template v-if="!isNoFolders">
        <ul>
          <draggable
            v-model="folders"
            handle=".group-handle"
            :disabled="model.searchText"
            @end="onDraggableEnd"
          >
            <li
              v-for="(folder, index) in folders"
              :key="index"
            >
              <div class="checkbox">
                <input
                  type="checkbox"
                  v-model="folder.checked"
                  :name="index"
                  :id="index"
                />
                <label :for="index"></label>
              </div>
              <div class="box-wrapper">
                <div class="info">
                  <div class="id"><span>ID</span>{{folder.innerId}}</div>
                  <div class="name-box">
                    <template v-if="folder.showInput.name">
                      <div class="main-input">
                        <input
                          type="text"
                          v-model="folder.name"
                          @keypress.enter="$event.target.blur"
                          @blur="toggleSave(folder, 'name', index)"
                          :ref="'name' + index"
                        />
                      </div>
                    </template>
                    <template v-else>
                      <span>{{ folder.name }}</span>
                    </template>
                    <span class="pen" v-if="!folder.showInput.name" @click="toggleShowInput(folder, 'name', index)"><i class="fas fa-pen"></i></span>
                  </div><!-- .nameBox -->
                  <div class="create">
                    <span>作成</span>
                    <span>{{ folder.createdOn }}</span>
                    <span>{{ folder.createdUserName }}</span>
                  </div>
                  <div class="update">
                    <span>更新</span>
                    <span>{{ folder.savedOn }}</span>
                    <span>{{ folder.modifiedUserName }}</span>
                  </div>
                </div><!-- .info -->
                <ul class="img-nav">
                  <li @click="deleteConfirm(folder)">削除</li>
                </ul>
                <div
                  v-if="sort.index === 0"
                  @mousedown="clickDragHandle"
                  class="group-handle"
                  title="ドラッグ＆ドロップで並び順を変更"
                />
              </div><!-- .box-wrapper -->
            </li>
          </draggable>
        </ul>
      </template>
      <template v-else>
        <div class="no-folders">
          <p>{{ displayKind }}グループがありません</p>
        </div>
      </template>
    </div><!-- .group-main -->
    <portal v-if="isShowDeletePopup" to="modal2">
      <modal @close="isShowDeletePopup = false">
        <template slot="title">削除確認</template>
        <template slot="name">{{ displayKind }}グループ {{ deletes.length }} 件を本当に削除してもよろしいでしょうか?</template>
        <template slot="submit">
          <div class="button-box">
            <button type="button" @click="deleteFolders" class="delete normal-btn">削除</button>
            <button type="button" @click="isShowDeletePopup = false" class="cancel normal-btn">キャンセル</button>
          </div>
        </template>
      </modal>
    </portal>
  </div><!-- .group -->
</template>

<script>
import { mixin as onClickAway } from 'vue-clickaway'
import Modal from '@/components/Util/Modal'
import Draggable from 'vuedraggable'

const MAX_GROUP_NAME_LENGTH = 25

const SORTS = [
  ['manual', 'asc'],
  ['innerId', 'asc'],
  ['innerId', 'desc'],
  ['name', 'asc'],
  ['name', 'desc'],
  ['createdOn', 'asc'],
  ['createdOn', 'desc'],
  ['createdUserName', 'asc'],
  ['createdUserName', 'desc'],
  ['savedOn', 'asc'],
  ['savedOn', 'desc'],
  ['modifiedUserName', 'asc'],
  ['modifiedUserName', 'desc'],
]

const initialData = () => {
  return {
    isNoFolders: false,
    isShowSortSelect: false,
    isShowDeletePopup: false,
    model: {
      searchText: null,
      name: '',
    },
    sort: {
      index: 0,
      target: 'manual',
      type: 'asc',
    },
    folders: [],
    deletes: [],
    count: null,
    limit: null,
    sortOption: false,
    batchFolderOption: false,
    isSending: false, // 処理中はtrue
  }
}

export default {
  mixins: [
    onClickAway
  ],
  components: {
    Modal,
    Draggable,
  },
  props: [
    'kind',
  ],
  data () {
    return initialData()
  },
  computed: {
    check: {
      get: function () {
        return this.folders.filter(folder => (folder.checked)).length
      },
      set: function (value) {
        this.folders.forEach(folder => { folder.checked = value })
      }
    },
    displayKind () {
      return this.kind === 'content' ? 'メーリング' : '画像'
    }
  },
  created () {
    this.initComponent()
  },
  methods: {
    initComponent () {
      this.getDefaultDisplay().then(() => this.getFolders())
    },
    sortSelectAway () {
      this.isShowSortSelect = false
    },
    onDraggableEnd () {
      let count = 1
      const formData = new FormData()
      this.folders.forEach(folder => {
        folder.sort = count++
        formData.append('folderIds[]', folder.id)
      })
      this.$http({
        url: `/folder/sort/${this.kind}`,
        type: 'POST',
        params: formData
      })
    },
    clickDragHandle () {
      if (this.model.searchText) {
        this.$store.commit('showErrorMessagePopup',
          ['絞り込み中は並び替え操作ができません']
        )
      }
    },
    getDefaultDisplay () {
      return this.$http({
        url: '/user/mphe_settings/default_display_' + (this.kind === 'content' ? 'content_folder' : 'image_folder'),
        type: 'GET',
      }).then(json => {
        if (json && json.status === 200) {
          const { sortTarget, sortType } = json.data.display
          this.sort = {
            index: SORTS.findIndex(sort => sort[0] === sortTarget && sort[1] === sortType),
            target: sortTarget,
            type: sortType
          }
        }
        return json
      })
    },
    changeSort (index, target, type) {
      this.isShowSortSelect = false
      this.sort = { index, target, type }
      this.getFolders()

      // 並び替え設定を保存
      const formData = new FormData()
      if (this.kind === 'content') {
        formData.append('contentFolderSortTarget', target)
        formData.append('ContentFolderSortType', type)
      } else {
        formData.append('imageFolderSortTarget', target)
        formData.append('imageFolderSortType', type)
      }
      this.$http({
        url: '/user/mphe_settings/change_default_display',
        type: 'POST',
        params: formData,
      })
    },
    async newFolder () {
      if (!this.model.name) {
        return this.$store.commit('showErrorMessagePopup',
          ['グループ名が入力されていません']
        )
      } else if ([...this.model.name].length > MAX_GROUP_NAME_LENGTH) {
        return this.$store.commit('showErrorMessagePopup',
          ['グループ名は最大' + MAX_GROUP_NAME_LENGTH + '字までです']
        )
      }
      if (this.isSending) return
      const formData = new FormData()
      formData.append('name', this.$utils.string.b64Encode(this.model.name))
      this.isSending = true
      const json = await this.$http({
        url: `/folder/new/${this.kind}`,
        type: 'POST',
        params: formData,
      })
      if (json && json.status === 200) {
        this.model.name = ''
        this.getFolders()
      }
      this.isSending = false
    },
    getFolders () {
      const searchText = this.model.searchText == null ? '' : this.model.searchText
      return this.$http({
        url: `/folder/${this.kind}?searchText=${searchText}&sortTarget=${this.sort.target}&sortType=${this.sort.type}`,
        type: 'GET',
      }).then(json => {
        if (json && json.status === 200) {
          this.folders = json.data.folders.map(folder => {
            return {
              ...folder,
              name: this.$utils.string.b64Decode(folder.name),
              checked: false,
              showInput: {
                name: false,
              }
            }
          })
          this.count = json.data.count
          this.limit = json.data.limit
          this.isNoFolders = (this.folders.length === 0)
        }
      })
    },
    toggleSave (folder, kind, index) {
      this.toggleShowInput(folder, kind)
      this.$nextTick(() => {
        if (!folder.showInput[kind]) {
          this.updateFolderInfo(folder, kind, index)
        }
      })
    },
    toggleShowInput (folder, kind, index) {
      folder.showInput[kind] = !folder.showInput[kind]
      this.$nextTick(() => {
        if (folder.showInput[kind]) {
          this.$refs[kind + index][0].focus()
        }
      })
    },
    updateFolderInfo (folder, kind, index) {
      if (folder.name === '') {
        this.getFolders()
        return this.$store.commit('showErrorMessagePopup',
          ['グループ名が入力されていません']
        )
      } else if ([...folder.name].length > MAX_GROUP_NAME_LENGTH) {
        // folder.name.length だと絵文字が2文字になってしまうため、分解する
        this.getFolders()
        return this.$store.commit('showErrorMessagePopup',
          ['グループ名は最大' + MAX_GROUP_NAME_LENGTH + '字までです']
        )
      }
      folder.name = folder.name.replace(/\r?\n/g, '')
      const formData = new FormData()
      formData.append('name', this.$utils.string.b64Encode(folder.name))
      this.$http({
        url: `/folder/save_info/${this.kind}/${folder.id}`,
        type: 'POST',
        params: formData,
      }).then(json => {
        if (json && json.status === 200) {
          folder.modifiedUserName = json.data.modifiedUserName
          folder.savedOn = json.data.savedOn
        }
      })
    },
    deleteConfirm (folder = false) { // 明示的に指定
      // 単体で削除 or チェックボックスで選択
      this.deletes = folder ? [ folder ] : this.folders.filter(folder => (folder.checked))
      this.isShowDeletePopup = true
    },
    deleteFolders () {
      const formData = new FormData()
      this.deletes.map(folder => {
        formData.append('folderIds[]', folder.id)
        return folder.id
      })
      this.$http({
        url: `/folder/delete/${this.kind}`,
        type: 'POST',
        params: formData
      }).then(json => {
        if (json && json.status === 200) {
          this.getFolders()
          this.deletes = []
        }
        this.isShowDeletePopup = false
      })
    },
    batchFolderHidden () {
      this.batchFolderOption = false
    },
  },
  watch: {
    kind () {
      // kind 変更時、初期化する
      Object.assign(this.$data, initialData())
      this.initComponent()
    }
  }
}
</script>
<style lang="scss" scoped>
.group {
  font-size: 14px;
  position: relative;
  .group-header {
    .sub-header {
      position: relative;
      margin-bottom: 20px;
      h5 {
        display: flex;
        align-items: center;
        padding-left: 20px;
        margin-bottom: 20px;
        font-size: 24px;
        span {
          display: inline-block;
          margin-right: 8px;
          height: 22px;
          line-height: 22px;
          &.mailing::before {
            content: '\f15b';
            font-family: "Font Awesome 5 Free";
          }
          &.image::before {
            content: '\f03e';
            font-family: "Font Awesome 5 Free";
          }
          &.count {
            font-size: 12px;
            border-radius: 13px;
            padding: 0 8px;
            margin-left: 8px;
            background: #e4e4e4;
          }
        }
      }
      // 検索と並べ替え
      .operation-area {
        position: absolute;
        top: 0;
        right: 0;
        .search {
          width: 400px;
          height: 35px;
          margin-right: 20px;
          display: block;
          position: relative;
          &>input {
            width: 100%;
            padding:0 10px;
            border-radius:2px;
            height: 35px;
            outline:0;
            background: #E4E4E4;
            position: absolute;
            left: 0;
            top: 0;
            &::-webkit-input-placeholder {
              position: relative;
              top: 0.05em;
            }
          }
          &>button {
            width: 50px;
            height: 35px;
            border-radius:0 2px 2px 0;
            outline:0;
            position: absolute;
            right: -20px;
            top: 0;
            background: none;
            transition: all 0.3s ease 0s;
            cursor: pointer;
            &:hover, &:active {
              background: #c6c6c6;
              transition: all 0.3s ease 0s;
            }
          }
        }
        .sort {
          margin: 0 0 20px auto;
          &::before {
            content: '\f161';
            font-family: "Font Awesome 5 Free";
            font-weight: 900;
          }
          .sort-option {
            right: 0;
            left: auto;
            width: 83px;
            li {
              position: relative;
              width: 100%;
              &.selected::before {
                content: '\f00c';
                font-family: "Font Awesome 5 Free";
                font-weight: 900;
                position: absolute;
                top: 0;
                left: -15px;
              }
            }
          }
        }
      }
    }
    // 一括操作のチェックボックス
    input[type=checkbox] {
      display:  none;
      + label {
        padding-left: 10px;
        font-size: 12px;
        margin-bottom: 0;
        display: inherit;
        line-height: 20px;
        &::before {
          width: 20px;
          height: 20px;
          box-sizing: border-box;
          vertical-align: bottom;
          margin-right: 8px;
          display: inline-block;
          content: '';
          border-radius: 4px;
          background: #cfcfcf;
        }
      }
      &:checked + label::before {
        font-size: 14px;
        font-family: "Font Awesome 5 Free";
        padding-left: 3px;
        content: '\f00c';
        display: inline-block;
        font-weight: 900;
      }
    }
    .check-wrapper {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .batch {
        display:flex;
        align-items: center;
        margin: 0 0 0 20px;
        width: 136px;
        li:not(:first-of-type) {
          span {
            display: inline-block;
            &::before, &::after {
              font-family: "Font Awesome 5 Free";
              font-weight: 900;
            }
            &::before {
              padding-right: 5px;
            }
          }
          &.delete {
            width: 80px;
            span::before {
              content: '\f2ed';
            }
          }
        }
      }
      .add-folder {
        width: 300px;
        height: 35px;
        margin-right: 48px;
        display: block;
        display: flex;
        &>input {
          width: 100%;
          padding:0 10px;
          border-radius:2px;
          height: 35px;
          outline:0;
          background: #E4E4E4;
          margin-right: 5px;
        }
        &>button {
          border-radius: 2px;
          opacity: 1;
          cursor: pointer;
          transition: all 0.3s ease 0s;
          &:hover, &:active {
            opacity: 0.8;
          }
        }
      }
    }
  }
  .group-main {
    margin-bottom: 60px;
    a {
      color: $commonFontColor;
    }
    .no-folders {
      width: 100%;
      height: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
      p {
        font-size: 14px;
      }
    }
    >ul {
      > div > li {
        background: #f8f8f8;
        padding: 15px 20px;
        padding-right: 0;
        border-bottom: 0.5px solid #C6C6C6;
        margin: 0 20px;
        position: relative;
        &:first-of-type {
          border-top: 0.5px solid #C6C6C6;
        }
        // 一括操作のチェックボックス
        .checkbox {
          position: absolute;
          top:20px;
          left: 10px;
          input[type=checkbox] {
            display:  none;
            + label {
              font-size: 12px;
              margin-bottom: 0;
              display: inherit;
              line-height: 20px;
              &::before {
                width: 20px;
                height: 20px;
                vertical-align: bottom;
                margin-right: 8px;
                display: inline-block;
                content: '';
                border-radius: 4px;
                background: #cfcfcf;
              }
            }
            &:checked + label::before {
              font-size: 14px;
              font-family: "Font Awesome 5 Free";
              padding-left: 3px;
              content: '\f00c';
              display: inline-block;
              font-weight: 900;
            }
          }
        }
        .box-wrapper {
          margin-left: 30px;
          display:flex;
          align-items: center;
        }
        .info {
          display: inline-block;
          flex: 1;
          .name-box {
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 5px;
            display: flex;
            > div {
              overflow: hidden;
            }
            span {
              cursor: pointer;
            }
            input {
              width: 100%;
              padding: 0 5px;
              border-radius: 2px;
              margin-bottom: 10px;
            }
          }
          button {
            display: inline;
          }
          .pen {
            padding-left: 3px;
          }
          .id, .create, .update {
            span {
              margin-right: 8px;
              &:first-of-type{
                display: inline-block;
                text-align: center;
                width: 40px;
                height: 21px;
                border-radius: 12px;
                background: #e4e4e4;
              }
            }
          }
          .id {
            font-size: 12px;
            color: rgba(#484848, 0.6);
            span {
              &:first-of-type {
                width: 30px;
                height: 19px;
              }
            }
          }
          .create, .update {
            margin-bottom: 2px;
            display: flex;
            span:nth-of-type(2) {
              min-width: 150px;
            }
          }
        }
        // 右側のメニュー
        .img-nav {
          margin: 0;
          > li {
            width: 96px;
            height: 54px;
            white-space: nowrap;
            font-weight: 300;
            border-radius: 2px;
            transition: all 0.3s ease 0s;
            text-align: center;
            padding-top: 12px;
            margin: 0 60px 0 10px;
            cursor: pointer;
            &:hover, &:active {
              background: #e4e4e4;
              transition: all 0.3s ease 0s;
              border-radius: 2px;
            }
            &::before {
              font-family: "Font Awesome 5 Free";
              display: block;
              text-align: center;
            }
            &:nth-of-type(1)::before {
              content: '\f2ed';
            }
          }
        }
        .group-handle {
          position: absolute;
          top: 45px;
          right: 1px;
          width: 40px;
          &::before {
            color: $commonFontColor;
            content: '\f0dc';
            cursor: pointer;
            font-family: "Font Awesome 5 Free";
            font-size: 24px;
            font-weight: 900;
          }
        }
      }
    }
  }
}
// モーダルの中身
.button-box {
  display: flex;
  justify-content: center;
  button {
    font-size: 14px;
    border: solid 1px #c6c6c6;
    border-radius: 5px;
    &:hover {
      opacity: 0.8;
    }
    &.delete {
      margin-right: 20px;
      color: #fff;
      border: solid 1px #484848;
      background: #484848;
    }
  }
}
</style>
